import { render } from "./DataScience.vue?vue&type=template&id=9eba6544"
import script from "./DataScience.vue?vue&type=script&lang=js"
export * from "./DataScience.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__